var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":_vm.book}},[_c('button',{staticClass:"expand",attrs:{"type":"submit"}},[_vm._v("Book Now")])])}
var staticRenderFns = []

export { render, staticRenderFns }